import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import classNames from 'classnames';
import TextButton from '../../../../../elements-buttons/text-button';
import AddOnField from '../../fields/AddOnField/AddOnField';
import TextField from '../../fields/TextField/TextField';
import SelectField from '../../fields/SelectField/SelectField';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { get, map } from 'lodash';

const translationMessages = defineMessages({
  taxFieldPlaceholder: {
    id: 'hosting.add_taxes.tax_field_placeholder',
    defaultMessage: 'Tax name, i.e. Sales tax'
  },
  taxFieldErrorMessage: {
    id: 'hosting.add_taxes.tax_field_error_message',
    defaultMessage: 'Please enter a title'
  }
});
export default class VatAddTaxes extends Component {
  constructor (props) {
    super(props);
    this.handleAddClick = this.handleAddClick.bind(this);
  }

  componentDidMount () {
    if (!this.props.addAddtlTaxes && 0 >= this.props.fields.length) {
      this.handleAddClick();
    }
  }

  handleAddClick (e) {
    if (e) { e.preventDefault(); }

    this.props.fields.push({
      charge_type: 'tax',
      charge_unit: '%'
    });
  }

  render () {
    const {
      classnames,
      fields,
      addAddtlTaxes,
      intlAddOnTaxTypes = [],
      addOnTaxValues = [],
      taxError
    } = this.props;

    return (
      <div className={classNames('add-taxes-component', classnames)}>
        {
          fields.map((tax, index) => {
            const currentTax = get(addOnTaxValues, index, {});

            const chargeType = get(currentTax, 'charge_type', '');
            const selectedTaxType = get(currentTax, 'label', '');

            return (
              <div className="tax-block margin-lg-bottom" key={tax}>
                <div className="flex space-between margin-sm-bottom">
                  <label className="label text-gray-dark" htmlFor="count">
                    <FormattedMessage
                      id="hosting.add_taxes.tax_item_label"
                      defaultMessage="Tax item {taxItemCount}"
                      values={{ taxItemCount: index + 1 }}
                    />
                  </label>

                  <TextButton
                    onClick={(e) => { e.preventDefault(); fields.remove(index); }}
                    buttonText={ this.props.intl.formatMessage({ id: 'hosting.add_taxes.button_text_remove', defaultMessage: 'Remove' }) }
                    attributes={{ 'data-testing-id': 'remove-tax-button' }}
                    classNames="underline no-padding"
                  />
                </div>
                <Field
                  name={`${tax}.label`}
                  component={SelectField}
                  options={intlAddOnTaxTypes}
                  className="form-fields margin-md-bottom"
                  placeholder={ this.props.intl.formatMessage({ id: 'hosting.add_taxes.tax_type_field_placeholder', defaultMessage: 'Tax type' }) }
                  errorMessage={ taxError ? null : this.props.intl.formatMessage({ id: 'hosting.add_taxes.select_tax_type', defaultMessage: 'Please select a tax type' }) }
                  attributes={{ 'data-testing-id': 'tax-label-field' }}
                  isError={!!taxError}
                />

                {
                  ('other' === selectedTaxType) &&
                  <Field
                    name={`${tax}.other_label`}
                    component={TextField}
                    className="margin-md-bottom"
                    isError={!!taxError}
                    errorMessage={ taxError ? null : this.props.intl.formatMessage({ id: 'hosting.add_taxes.tax_name_error', defaultMessage: 'Please enter a tax name' }) }
                    placeholder={ this.props.intl.formatMessage({ id: 'hosting.add_taxes.tax_name', defaultMessage: 'Tax name' }) }
                  />

                }
                <Field
                  name={`${tax}.amount`}
                  fieldType="number"
                  component={AddOnField}
                  isError={!!taxError}
                  label="%"
                  className="tax-field"
                  attributes={{ 'data-testing-id': 'tax-amount-field' }}
                />
                {taxError && <div className="help-block text-danger">
                  {taxError}
                </div>}
                { addAddtlTaxes &&
                  <div className="flex space-between margin-md-top">
                    <div>
                      {
                        (index === fields.length - 1) &&
                        <TextButton
                          onClick={this.handleAddClick}
                          buttonText={ this.props.intl.formatMessage({ id: 'hosting.add_taxes.button_text_add_more', defaultMessage: 'Add more' }) }
                          attributes={{ 'data-testing-id': 'add-more-taxes-button' }}
                          classNames="underline no-padding"
                        />
                      }
                    </div>
                  </div> }
              </div>
            );
          })
        }

        {
          0 >= fields.length && addAddtlTaxes &&
          <div>
            <TextButton
              onClick={this.handleAddClick}
              buttonText={ this.props.intl.formatMessage({ id: 'hosting.add_taxes.button_text_only_add_tax', defaultMessage: 'Add tax' }) }
              attributes={{ 'data-testing-id': 'add-tax-button' }}
              classNames="underline no-padding"
            />
          </div>
        }
      </div>
    );
  }
}

export const VatAddTaxesIntl = injectIntl(VatAddTaxes);

VatAddTaxes.propTypes = {
  classnames: PropTypes.string,
  fields: PropTypes.object,
  addAddtlTaxes: PropTypes.bool
};
